"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "import-text" };
const _hoisted_3 = { class: "import-box-text" };
const _hoisted_4 = { class: "current-file-name" };
const _hoisted_5 = {
    class: "image-file-label",
    for: "staff-image-file"
};
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../Modal.vue"));
const settings_js_1 = require("../../js/settings.js");
const vue_i18n_1 = require("vue-i18n");
const FILE_SIZE_LIMIT = 10 * 1024 * 1024; // 10 MB
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProfilePhotoModal',
    props: {
        userId: {
            type: Number,
            required: true,
        },
        thisUserId: {
            type: Number,
            required: false,
        },
        isBranchUserPage: {
            type: Boolean,
            default: false,
        },
        branchId: {
            type: Number,
            required: false,
        },
    },
    emits: ["update-profile-photo", "open-alert-modal"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const props = __props;
        const emits = __emit;
        const isImporting = (0, vue_3.ref)(false);
        const isDragging = (0, vue_3.ref)(false);
        const selectedFile = (0, vue_3.ref)(null);
        const isVisible = (0, vue_3.ref)(false);
        const currentFileName = (0, vue_3.computed)(() => {
            return selectedFile.value ? selectedFile.value.name : t("profile_photo.select");
        });
        function openModal() {
            isVisible.value = true;
        }
        __expose({
            openModal,
        });
        function closeModal() {
            isVisible.value = false;
        }
        function isImageFile(file) {
            const extension = file?.name.split('.').pop()?.toLowerCase();
            return extension === "jpeg" || extension === "jpg" || extension === "png";
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return isImporting.value ? "loading" : "";
        });
        function handleFileDrop(event) {
            const dragEvent = event;
            isDragging.value = false;
            const file = dragEvent.dataTransfer?.files?.[0];
            if (!file) {
                return;
            }
            if (!isImageFile(file)) {
                (0, settings_js_1.importAlertModal)().alert(t("profile_photo.error_format"));
                return;
            }
            if (file.size > FILE_SIZE_LIMIT) {
                (0, settings_js_1.importAlertModal)().alert(t("profile_photo.error_size"));
                return;
            }
            selectedFile.value = file;
        }
        function handleFileChange(event) {
            const target = event.target;
            if (!target.files?.length) {
                return;
            }
            let file = target.files[0];
            if (!file || !isImageFile(file)) {
                (0, settings_js_1.importAlertModal)().alert(t("profile_photo.error_format"));
                return;
            }
            ;
            if (file.size > FILE_SIZE_LIMIT) {
                (0, settings_js_1.importAlertModal)().alert(t("profile_photo.error_size"));
                return;
            }
            selectedFile.value = file;
        }
        async function importSelfImage() {
            isImporting.value = true;
            if (!selectedFile.value || !isImageFile(selectedFile.value)) {
                (0, settings_js_1.importAlertModal)().alert(t("profile_photo.error_format"));
                isImporting.value = false;
                return;
            }
            ;
            const formData = new FormData();
            formData.append("image", selectedFile.value);
            try {
                const response = await fetch(`/dashboard/${props.userId}/user_profile_photo`, {
                    method: 'PUT',
                    body: formData,
                });
                if (!response.ok) {
                    throw response;
                }
                const result = await response.json();
                if (result.success) {
                    emits("update-profile-photo", result.ImageURL);
                }
                isVisible.value = false;
            }
            catch (err) {
                (0, settings_js_1.importAlertModal)().alert(t("general.error_reload"));
            }
            finally {
                isImporting.value = false;
                selectedFile.value = null;
            }
        }
        async function importStaffImage() {
            isImporting.value = true;
            if (!selectedFile.value || !isImageFile(selectedFile.value)) {
                (0, settings_js_1.importAlertModal)().alert(t("profile_photo.error_format"));
                isImporting.value = false;
                return;
            }
            ;
            const formData = new FormData();
            formData.append("image", selectedFile.value);
            formData.append("userID", props.thisUserId?.toString() || "");
            formData.append("branchID", props.branchId?.toString() || "");
            try {
                const response = await fetch(`/dashboard/${props.userId}/staff_profile_photo`, {
                    method: 'PUT',
                    body: formData,
                });
                if (!response.ok) {
                    throw response;
                }
                const result = await response.json();
                if (result.success) {
                    emits("update-profile-photo", result.ImageURL);
                }
                isVisible.value = false;
            }
            catch (err) {
                (0, settings_js_1.importAlertModal)().alert(t("general.error_reload"));
            }
            finally {
                isImporting.value = false;
                selectedFile.value = null;
            }
        }
        async function deleteSelfImage() {
            isImporting.value = true;
            try {
                const response = await fetch(`/dashboard/${props.userId}/user_profile_photo`, {
                    method: 'DELETE',
                });
                if (!response.ok) {
                    throw response;
                }
                const result = await response.json();
                if (result.success) {
                    emits("update-profile-photo", "");
                }
                isVisible.value = false;
            }
            catch (err) {
                (0, settings_js_1.importAlertModal)().alert(t("general.error_reload"));
            }
            finally {
                isImporting.value = false;
                selectedFile.value = null;
            }
        }
        async function deleteStaffImage() {
            isImporting.value = true;
            const formData = new FormData();
            formData.append("userID", props.thisUserId?.toString() || "");
            formData.append("branchID", props.branchId?.toString() || "");
            try {
                const response = await fetch(`/dashboard/${props.userId}/staff_profile_photo`, {
                    method: 'POST',
                    body: formData,
                });
                if (!response.ok) {
                    throw response;
                }
                const result = await response.json();
                if (result.success) {
                    emits("update-profile-photo", "");
                }
                isVisible.value = false;
            }
            catch (err) {
                (0, settings_js_1.importAlertModal)().alert(t("general.error_reload"));
            }
            finally {
                isImporting.value = false;
                selectedFile.value = null;
            }
        }
        function onConfirm() {
            if (isImporting.value) {
                return;
            }
            if (props.isBranchUserPage) {
                importStaffImage();
                return;
            }
            importSelfImage();
        }
        function onDelete() {
            if (isImporting.value) {
                return;
            }
            if (props.isBranchUserPage) {
                deleteStaffImage();
                return;
            }
            deleteSelfImage();
        }
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    "has-title-divider": true,
                    "has-footer-divider": false
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("profile_photo.title")), 1 /* TEXT */)
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.renderSlot)(_ctx.$slots, "import-text", {}, () => [
                                (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("profile_photo.import")), 1 /* TEXT */)
                            ]),
                            _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("br", null, null, -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("div", {
                                class: (0, vue_2.normalizeClass)(["import-box", { hover: isDragging.value }]),
                                id: "drop-area",
                                onDragenter: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(($event) => (isDragging.value = true), ["prevent"])),
                                onDragover: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(($event) => (isDragging.value = true), ["prevent"])),
                                onDragleave: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (isDragging.value = false), ["prevent"])),
                                onDrop: (0, vue_2.withModifiers)(handleFileDrop, ["prevent"])
                            }, [
                                _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("img", {
                                    class: "import-box-bg",
                                    alt: "",
                                    "aria-hidden": "true",
                                    src: "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23333' stroke-width='3' stroke-dasharray='4%2c10' stroke-dashoffset='12' stroke-linecap='round'/%3e%3c/svg%3e"
                                }, null, -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("profile_photo.upload")), 1 /* TEXT */),
                                _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("div", null, [
                                    (0, vue_2.createElementVNode)("svg", {
                                        version: "1.1",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                        x: "0px",
                                        y: "0px",
                                        "xml:space": "preserve",
                                        viewBox: "0 0 85 85",
                                        id: "upload-icon",
                                        width: "100px"
                                    }, [
                                        (0, vue_2.createElementVNode)("path", {
                                            fill: "#52a3d5",
                                            d: "M71.1,29.6c0-0.3,0-0.6,0-0.9c0-7.5-6.1-13.5-13.5-13.5c-3,0-5.8,1-8.2,2.8C47,11.8,40.9,7.5,34.2,7.5\n              c-9,0-16.2,7.3-16.2,16.3c0,1.8,0,4.2-0.1,5.4c-9,0.5-16.6,7.9-16.6,16.3c0,5.9,3.2,11.4,8.4,14.2c0.2,0.1,0.3,0.1,0.5,0.1h11\n              c0,0.1,0,0.2,0,0.3c0,12.1,9.9,22,22,22c12.1,0,22-9.9,22-22c0-0.1,0-0.2,0-0.3h10.1c0.2,0,0.4,0,0.5-0.1c5.2-2.9,8.4-8.3,8.4-14.2\n              C84.1,37.8,78.6,31.1,71.1,29.6z M43.1,80.1c-11,0-19.9-8.9-19.9-19.9c0-11,8.9-19.9,19.9-19.9c11,0,19.9,8.9,19.9,19.9\n              C63,71.1,54.1,80.1,43.1,80.1z M74.9,57.8H65c-1.2-11-10.6-19.6-21.9-19.6c-11.3,0-20.7,8.6-21.9,19.6H10.4\n              c-4.4-2.5-7.1-7.2-7.1-12.3c0-7.5,7.3-14.2,15.5-14.2c1.1,0,1.1-0.5,1.1-3.3c0-1.3,0-2.9,0-4.2c0-7.8,6.3-14.2,14.1-14.2\n              c6.3,0,12,4.3,13.7,10.4c0.1,0.4,0.4,0.6,0.7,0.7c0.4,0.1,0.8,0,1-0.3c2.2-2.1,5-3.2,8-3.2c6.3,0,11.4,5.1,11.4,11.4\n              c0,0.6,0,1.1-0.1,1.5c-0.1,0.3,0,0.6,0.2,0.8c0.2,0.2,0.4,0.4,0.7,0.4c7,0.9,12.2,6.9,12.2,14C82,50.5,79.3,55.2,74.9,57.8z\n              M49.1,57.1c-0.4,0.4-1.1,0.5-1.5,0.1l-3.4-3v15.7c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1V54.2l-3.4,3\n              c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.8-0.4c-0.4-0.4-0.3-1.1,0.1-1.5l5.2-4.6c0.4-0.3,1-0.3,1.4,0l5.2,4.6\n              C49.4,56,49.5,56.7,49.1,57.1z"
                                        })
                                    ])
                                ], -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(currentFileName.value), 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("span", null, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("profile_photo.drag")) + " ", 1 /* TEXT */),
                                    (0, vue_2.createElementVNode)("label", _hoisted_5, [
                                        (0, vue_2.createElementVNode)("input", {
                                            type: "file",
                                            name: "file",
                                            id: "staff-image-file",
                                            onChange: handleFileChange
                                        }, null, 32 /* NEED_HYDRATION */),
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("profile_photo.browse")), 1 /* TEXT */)
                                    ])
                                ])
                            ], 34 /* CLASS, NEED_HYDRATION */)
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("button", {
                            class: "oplus-modal-btn delete-photo text-error float-left",
                            onClick: onDelete
                        }, [...(_cache[6] || (_cache[6] = [
                                (0, vue_2.createElementVNode)("i", { class: "icon icon-delete" }, null, -1 /* CACHED */)
                            ]))]),
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                            onClick: onConfirm
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("general.save")), 3 /* TEXT, CLASS */)
                    ]),
                    _: 3 /* FORWARDED */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
